import React from 'react'
import { Helmet } from "react-helmet";
import ShortTerm from '../../components/Courses/ShortTerm/ShortTerm';

const ShortTermPage = () => {
  return (
    <>
<Helmet>
  {/* Google Analytics Tag */}
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16818142902');
    `}
  </script>

  {/* Basic Meta */}
  <title>Short-Term IT Courses | Aptech Lekki Centre - Learn New Tech Skills Fast</title>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  
  <meta
    name="description"
    content="Fast-track your tech career with Aptech Lekki's short-term IT courses. Learn Web Development, Graphic Design, Digital Marketing, and essential tech skills in just a few weeks. Flexible, practical, and career-focused training in Lekki, Lagos."
  />
  
  <meta
    name="keywords"
    content="Short-term IT courses Lekki, Learn programming fast Lagos, Quick tech skills Nigeria, Web development short course, Digital marketing crash course Lekki, Graphic design training Lekki, Upskill in IT Nigeria, Short certificate programs Lagos, Fast track tech training Lekki"
  />
  
  <meta name="author" content="Aptech Lekki Centre" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://aptechlekki.com/courses/short-term" />

  {/* Open Graph Meta for social media */}
  <meta property="og:title" content="Short-Term IT Courses | Aptech Lekki Centre" />
  <meta property="og:description" content="Learn essential tech skills quickly with Aptech Lekki's short-term IT courses. Flexible programs designed for busy individuals and career movers." />
  <meta property="og:url" content="https://aptechlekki.com/courses/short-term" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://aptechlekki.com/assets/og_image.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Short-Term IT Courses | Aptech Lekki Centre" />
  <meta name="twitter:description" content="Boost your career fast with Aptech Lekki's short-term tech training. Start learning today!" />
  <meta name="twitter:image" content="https://aptechlekki.com/assets/og_image.jpg" />
</Helmet>
    <ShortTerm />
    </>
  )
}

export default ShortTermPage